import { createAction } from 'typesafe-actions';
import { IPumpingStationFlowmeterSize } from '../../../../@types/model/masterData/pumpingStation/flowmeterSize';

export default class MasterDataPumpingStationFlowmeterSizeActions {
    public static readonly set = createAction('MASTER_DATA_SET_PUMPING_STATION_FLOWMETER_SIZES', resolve => (pumps : Array<IPumpingStationFlowmeterSize>) => resolve(pumps));
    public static readonly setLoading = createAction('MASTER_DATA_SET_PUMPING_STATION_FLOWMETER_SIZES_LOADING', resolve => (isLoading : boolean) => resolve(isLoading));
}